import { render, staticRenderFns } from "./toggle-switch.vue?vue&type=template&id=05cb38d2"
import script from "./toggle-switch.vue?vue&type=script&lang=js"
export * from "./toggle-switch.vue?vue&type=script&lang=js"
import style0 from "./toggle-switch.vue?vue&type=style&index=0&id=05cb38d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports